import api from "./axios";

export const createExhibitor = async (payload) => {
  const response = await api.post("/exhibitor", payload);
  return response.data;
};

export const getExhibitor = async (companyId, params = {}) => {
  const response = await api.get(`/exhibitor/company/${companyId}`, {
    params,
    signal: params.signal, // Pass AbortController signal if provided
  });
  return response.data;
};;

export const getExhibitorById = (id) => {
  return api.get(`/exhibitor/${id}`);
};

export const updateExhibitor = async (id, payload) => {
  const response = await api.put(`/exhibitor/${id}`, payload);
  return response.data;
};

export const deleteExhibitor = (id, payload) => {
  return api.put(`/exhibitor/delete/${id}`, payload);    
};

export const getExhibitorDropdown = async (companyId) => {
  const response = await api.get(`/exhibitor/dropdown/${companyId}`);
  return response.data;
};;